import * as React from 'react'
import {
  List,
  FunctionField,
  Link,
  TextInput,
  SelectInput,
  TopToolbar,
  SelectColumnsButton,
  FilterButton,
  ReferenceInput,
  DatagridConfigurable,
  ReferenceField,
  TextField,
  number,
} from 'react-admin'
import {
  LabField,
  NotificationField,
  PatientField,
  ProviderField,
  ShipField,
  ShopifyCustomerAndLineDetail,
  StatusField,
  ToolTip,
} from '../fields/kitFields'
import { KitActions } from '../fields/helpers/kitFieldsHelpers'
import CouponPreflightProvider from '../buttons/CouponPreflightProvider'
import { BulkActionsKit } from '../../utils/bulkProgressKit'
import TestRecordModal from '../modals/TestRecordModal'
import StatusDetailModal from '../modals/StatusDetailModal'

const KitFilters = () => {
  const filters = [
    <TextInput
      label="Enter Kit Id / Tracking Number"
      source="q"
      resettable
      alwaysOn
      style={{ width: '320px' }}
      validate={number()}
    />,
    <ReferenceInput source="providerId" reference="providers" alwaysOn>
      <SelectInput optionText={'displayName'} emptyText="All Providers" />
    </ReferenceInput>,
    <TextInput label="Order Number" source="shopifyOrderNumber" resettable alwaysOn style={{ width: '120px' }} />,
  ]

  return filters
}

const KitList = (props) => {
  const [openModal, setOpenModal] = React.useState(false)
  const [modalState, setModalState] = React.useState(null)

  const handleModalClose = () => {
    setOpenModal(false)
    setModalState(null)
  }

  const handleModalOpen = (record) => {
    setModalState(record)
    setOpenModal(true)
  }

  const [statusDetailModalOpen, setStatusDetailModalOpen] = React.useState(false)
  const [statusDetailTarget, setStatusDetailTarget] = React.useState('')
  const [statusDetailRecord, setStatusDetailRecord] = React.useState(null)

  const handleStatusDetailModalClose = () => {
    setStatusDetailModalOpen(false)
    setStatusDetailTarget('')
    setStatusDetailRecord(null)
  }

  const handleStatusDetailModalOpen = (record, targetStatus) => {
    setStatusDetailRecord(record)
    setStatusDetailTarget(targetStatus)
    setStatusDetailModalOpen(true)
  }

  return (
    <>
      <List
        {...props}
        filter={{ _order: 'DESC' }}
        actions={
          <TopToolbar>
            <FilterButton />
            <SelectColumnsButton />
          </TopToolbar>
        }
        filters={KitFilters()}
      >
        <CouponPreflightProvider>
          <DatagridConfigurable bulkActionButtons={<BulkActionsKit />}>
            <FunctionField
              style={{ width: 'fit-content' }}
              label="KitId"
              render={(record) => <Link to={`/kits/${record.id}/show`}>{record.kitId}</Link>}
            />

            <ReferenceField link="show" label="OrderNum" reference="orders" source="orderId">
              <TextField source="shopifyOrderNumber" label="ShopifyOrderNumber" />
            </ReferenceField>
            <ToolTip label="Pic" />
            <ReferenceField link="show" label="OrderDetail" reference="orders" source="orderId">
              <ShopifyCustomerAndLineDetail />
            </ReferenceField>
            <PatientField label="Patient Info" />
            <ProviderField label="Provider Info" />
            <StatusField label="Status" />
            <ShipField label="Ship" />
            <LabField label="Lab" />
            <NotificationField label="Notification/Views" />
            <KitActions
              handleModalOpen={handleModalOpen}
              handleStatusDetailModalOpen={handleStatusDetailModalOpen}
              label="Actions"
            />
          </DatagridConfigurable>
        </CouponPreflightProvider>
      </List>
      {openModal && <TestRecordModal modalState={modalState} open={openModal} handleClose={handleModalClose} />}
      {statusDetailModalOpen && (
        <StatusDetailModal
          open={statusDetailModalOpen}
          handleClose={handleStatusDetailModalClose}
          record={statusDetailRecord}
          targetStatus={statusDetailTarget}
        />
      )}
    </>
  )
}

export default KitList
